/**
 * Preparation du terme de recherche, cote navigateur.
 *
 * CE MODULE N'ECHAPPE RIEN ET NE CONSTRUIT AUCUN MOTIF.
 *
 * La normalisation qui compte — minuscules, accents retires, et surtout
 * l'echappement de %, _ et \ — vit dans `app.normaliser_terme_recherche`
 * (migration 0006), appelee par `public.rechercher_dossiers`. Un seul endroit,
 * donc un seul comportement : la reecrire ici en donnerait deux, qui
 * divergeraient au premier correctif applique d'un seul cote.
 *
 * Ce qui reste legitimement ici : de quoi decider si l'utilisateur a saisi
 * quelque chose, et de quoi fabriquer une cle de cache stable. Rien de plus.
 */

/** Supprime les espaces de bord et reduit les suites d'espaces a un seul. */
export function preparerTerme(terme: string): string {
  return terme.trim().replace(/\s+/g, ' ')
}

/**
 * Un terme est vide s'il ne reste rien apres nettoyage.
 *
 * Aucune longueur minimale : « ma » doit fonctionner. Le cahier des charges
 * demande une recherche sur une suite de caracteres n'importe ou dans le nom,
 * et imposer trois caracteres exclurait des noms courts bien reels.
 */
export function termeEstVide(terme: string): boolean {
  return preparerTerme(terme).length === 0
}

/** Delai avant declenchement, apres la derniere frappe. */
export const DELAI_FRAPPE_MS = 300
